import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { UtilsService } from './../_services/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./utils.service";
var RankemService = /** @class */ (function () {
    function RankemService(http, _utilsService) {
        this.http = http;
        this._utilsService = _utilsService;
    }
    RankemService.prototype.getLeagueDetail = function (draft_id, uuid, lgm_id) {
        if (lgm_id === void 0) { lgm_id = null; }
        if (lgm_id)
            return this._utilsService.getRequest("" + environment.boxScoreUrl + '/getRankemData/' + draft_id + '/' + uuid + '/' + lgm_id);
        else
            return this._utilsService.getRequest("" + environment.boxScoreUrl + '/getRankemData/' + draft_id + '/' + uuid);
    };
    RankemService.ngInjectableDef = i0.defineInjectable({ factory: function RankemService_Factory() { return new RankemService(i0.inject(i1.HttpClient), i0.inject(i2.UtilsService)); }, token: RankemService, providedIn: "root" });
    return RankemService;
}());
export { RankemService };
